import inputKey from './inputKey'
const openArgument = new Map(
  [
    ["baidu",inputKey.baidu]
    ,["百度",inputKey.baidu]

    ,["ecosia",inputKey.ecosia]

    ,["google",inputKey.google]
    ,["谷歌",inputKey.google]
    ,["guge",inputKey.google]

    ,["雅虎",inputKey.yahoo]
    ,["yahoo",inputKey.yahoo]
    ,["yahu",inputKey.yahoo]

    ,["bing",inputKey.bing]
    ,["必应",inputKey.bing]
    ,["biying",inputKey.bing]

    ,["360搜索",inputKey.qihu]
    ,["360sousuo",inputKey.qihu]

    ,["搜狗",inputKey.sougou]
    ,["sougou",inputKey.sougou]

    ,["soso",inputKey.soso]
    ,["搜搜",inputKey.soso]
    ,["sousou",inputKey.soso]

    ,["优酷",inputKey.youku]
    ,["youku",inputKey.youku]

    ,["土豆",inputKey.tudou]
    ,["tudou",inputKey.tudou]

    ,["腾讯视频",inputKey.qqVideo]
    ,["qq视频",inputKey.qqVideo]
    ,["qqshipin",inputKey.qqVideo]
    ,["tengxunshipin",inputKey.qqVideo]
    ,["qqvideo",inputKey.qqVideo]
    ,["Tencentvideo",inputKey.qqVideo]

    ,["爱奇艺",inputKey.iqiyi]
    ,["aiqiyi",inputKey.iqiyi]
    ,["iqiyi",inputKey.iqiyi]

    ,["哔哩哔哩",inputKey.bilibili]
    ,["bilibili",inputKey.bilibili]
    ,["b站",inputKey.bilibili]
    ,["bzhan",inputKey.bilibili]

    ,["芒果tv",inputKey.mgtv]
    ,["mangguotv",inputKey.mgtv]
    ,["mgtv",inputKey.mgtv]

    ,["搜狐视频",inputKey.sohutv]
    ,["souhushipin",inputKey.sohutv]
    ,["sohutv",inputKey.sohutv]

    ,["乐视",inputKey.le]
    ,["leshi",inputKey.le]
    ,["le",inputKey.le]

    ,["acfun",inputKey.acfun]
    ,["a站",inputKey.acfun]
    ,["azhan",inputKey.acfun]

    ,["nico",inputKey.nico]

    ,["youtube",inputKey.youtube]

    ,["qq音乐",inputKey.qqmusic]
    ,["qqmusic",inputKey.qqmusic]
    ,["qqyinyue",inputKey.qqmuaic]

    ,["虾米音乐",inputKey.xiamimusic]
    ,["xiamimusic",inputKey.xiamimusic]
    ,["虾米",inputKey.xiamimusic]
    ,["xiami",inputKey.xiamimusic]

    ,["网易云音乐",inputKey.netmusic]
    ,["netmusic",inputKey.netmusic]
    ,["wangyiyunyinyue",inputKey.netmusic]

    ,["酷狗",inputKey.kugoumusic]
    ,["酷狗音乐",inputKey.kugoumusic]
    ,["kugouyinyue",inputKey.kugoumusic]
    ,["kugou",inputKey.kugoumusic]
    ,["kugoumusic",inputKey.kugoumusic]

    ,["youtubemusic",inputKey.youtubemusic]

    ,["百度音乐",inputKey.baidumusic]
    ,["千千音乐",inputKey.baidumusic]
    ,["baiduyinyue",inputKey.baidumusic]
    ,["qianqianyinyue",inputKey.baidumusic]
    ,["baidumusic",inputKey.baidumusic]

    ,["音悦台",inputKey.yinyuetai]
    ,["yinyuetai",inputKey.yinyuetai]

    ,["qq音乐mv",inputKey.qqmusicmv]
    ,["qqmusicmv",inputKey.qqmusicmv]
    ,["qqyinyuemv",inputKey.qqmusicmv]

    ,["知乎",inputKey.zhihu]
    ,["zhihu",inputKey.zhihu]

    ,["百度知道",inputKey.baiduzhidao]
    ,["baiduzhidao",inputKey.baiduzhidao]

    ,["百度百科",inputKey.baidubaike]
    ,["baidubaike",inputKey.baidubaike]

    ,["搜狗百科",inputKey.sougoubaike]
    ,["sougoubaike",inputKey.sougoubaike]

    ,["360百科",inputKey.qihubaike]
    ,["360baike",inputKey.qihubaike]

    ,["互动百科",inputKey.hudongbaike]
    ,["hudongbaike",inputKey.hudongbaike]

    ,["维基百科",inputKey.wikibaike]
    ,["weijibaike",inputKey.wikibaike]
    ,["维基",inputKey.wikibaike]
    ,["weiji",inputKey.wikibaike]

    ,["baiduxinwen",inputKey.baiduxinwen]
    ,["百度新闻",inputKey.baiduxinwen]

    ,["腾讯新闻",inputKey.qqxinwen]
    ,["qq新闻",inputKey.qqxinwen]
    ,["tengxunxinwen",inputKey.qqxinwen]
    ,["qqxinwen",inputKey.qqxinwen]
    ,["tencentnews",inputKey.qqxinwen]
    ,["qqnews",inputKey.qqxinwen]

    ,["网易新闻",inputKey.netxinwen]
    ,["wangyixinwen",inputKey.netxinwen]
    ,["netnews",inputKey.netxinwen]

    ,["搜狐新闻",inputKey.sohuxinwen]
    ,["souhuxinwen",inputKey.sohuxinwen]
    ,["sohunews",inputKey.sohuxinwen]

    ,["新浪新闻",inputKey.sinaxinwen]
    ,["xinlangxinwen",inputKey.sinaxinwen]
    ,["sinanews",inputKey.sinaxinwen]

    ,["淘宝",inputKey.taobao]
    ,["taobao",inputKey.taobao]

    ,["京东",inputKey.jd]
    ,["jingdong",inputKey.jd]

    ,["天猫",inputKey.tmall]
    ,["tianmao",inputKey.tmall]
    ,["tmall",inputKey.tmall]

    ,["亚马逊",inputKey.amazoncn]
    ,["亚马逊中国",inputKey.amazoncn]
    ,["yamaxun",inputKey.amazoncn]
    ,["yamaxunzhongguo",inputKey.amazoncn]
    ,["amazoncn",inputKey.amazoncn]

    ,["亚马逊国际",inputKey.amazon]
    ,["yamaxunguoji",inputKey.amazon]
    ,["amazon",inputKey.amazon]

    ,["github",inputKey.github]

    ,["oschina",inputKey.oschina]
    ,["开源中国",inputKey.oschina]
    ,["kaiyuanzhongguo",inputKey.oschina]

    ,["segmentfault",inputKey.segmentfault]
    ,["思否",inputKey.segmentfault]
    ,["sifou",inputKey.segmentfault]

    ,["stackoverflow",inputKey.stackoverflow]

    ,["腾讯网",inputKey.qq]
    ,["腾讯",inputKey.qq]
    ,["tencent",inputKey.qq]
    ,["tengxunwang",inputKey.qq]
    ,["tengxun",inputKey.qq]

    ,["hao123",inputKey.hao123]
    ,["好123",inputKey.hao123]

    ,["搜狐",inputKey.sohu]
    ,["sohu",inputKey.sohu]
    ,["搜狐网",inputKey.sohu]
    ,["souhu",inputKey.sohu]
    ,["souhuwang",inputKey.sohu]

    ,["新浪",inputKey.sina]
    ,["新浪网",inputKey.sina]
    ,["xinlang",inputKey.sina]
    ,["xinlangwang",inputKey.sina]
    ,["sina",inputKey.sina]

    ,["google翻译",inputKey.googletranslate]
    ,["谷歌翻译",inputKey.googletranslate]
    ,["gugefanyi",inputKey.googletranslate]
    ,["googlefanyi",inputKey.googletranslate]
    ,["googletranslate",inputKey.googletranslate]

    ,["百度文库",inputKey.baiduwenku]
    ,["baiduwenku",inputKey.baiduwenku]

    ,["百度网盘",inputKey.baiduwangpan]
    ,["baiduwangpan",inputKey.baiduwangpan]

    ,["115",inputKey.yaoyaowu]
    ,["115wangpan",inputKey.yaoyaowu]
    ,["115网盘",inputKey.yaoyaowu]

    ,["新华网",inputKey.xinhuawang]
    ,["xinhuawang",inputKey.xinhuawang]

    ,["xinlangboke",inputKey.sinablog]
    ,["sinablog",inputKey.sinablog]
    ,["新浪博客",inputKey.sinablog]

    ,["人民日报",inputKey.renminribao]
    ,["renminribao",inputKey.renminribao]

    ,["光明网",inputKey.gmw]
    ,["guangmingwang",inputKey.gmw]

    ,["天涯",inputKey.tianya]
    ,["tianya",inputKey.tianya]
    ,["天涯社区",inputKey.tianya]
    ,["tianyashequ",inputKey.tianya]

    ,["中国青年网",inputKey.youth]
    ,["zhongguoqingnianwang",inputKey.youth]

    ,["中华网",inputKey.china]
    ,["zhonghuawang",inputKey.china]

    ,["cctv",inputKey.cctv]
    ,["yangshiwang",inputKey.cctv]
    ,["央视网",inputKey.cctv]
    ,["中央电视台",inputKey.cctv]
    ,["zhongyangdianshitai",inputKey.cctv]

    ,["alipay",inputKey.alipay]
    ,["支付宝",inputKey.alipay]
    ,["zhifubao",inputKey.alipay]

    ,["宝宝树",inputKey.babytree]
    ,["baobaoshu",inputKey.babytree]

    ,["环球网",inputKey.huanqiu]
    ,["huanqiuwang",inputKey.huanqiu]

    ,["csdn",inputKey.csdn]

    ,["妈妈网",inputKey.mamawang]
    ,["mamawang",inputKey.mamawang]

    ,["中关村在线",inputKey.zol]
    ,["zhongguancunzaixian",inputKey.zol]
    ,["zol",inputKey.zol]

    ,["网易",inputKey.net163]
    ,["wangyi",inputKey.net163]
    ,["163",inputKey.net163]

    ,["斗鱼",inputKey.douyu]
    ,["douyu",inputKey.douyu]
    ,["斗鱼tv",inputKey.douyu]
    ,["douyutv",inputKey.douyu]
    ,["斗鱼直播",inputKey.douyu]
    ,["douyuzhibo",inputKey.douyu]

    ,["易车网",inputKey.bitauto]
    ,["yichewang",inputKey.bitauto]
    ,["bitauto",inputKey.bitauto]

    ,["豆瓣",inputKey.douban]
    ,["douban",inputKey.douban]

    ,["财经网",inputKey.caijing]
    ,["caijingwang",inputKey.caijing]

    ,["天极网",inputKey.yesky]
    ,["tianjiwang",inputKey.yesky]
    ,["yesky",inputKey.yesky]

    ,["电影网",inputKey.dianying1905]
    ,["dianyingwang",inputKey.dianying1905]
    ,["1905",inputKey.dianying1905]

    ,["中国互联网络信息中心",inputKey.cnnic]
    ,["zhongguohulianwangluoxinxizhongxin",inputKey.cnnic]
    ,["cnnic",inputKey.cnnic]

    ,["博客园",inputKey.cnblogs]
    ,["bokeyuan",inputKey.cnblogs]

    ,["中国日报",inputKey.zhongguoribao]
    ,["zhongguoribao",inputKey.zhongguoribao]

    ,["阿里巴巴",inputKey.alibaba]
    ,["alibaba",inputKey.alibaba]

    ,["苹果官网",inputKey.apple]
    ,["pingguoguanwang",inputKey.apple]
    ,["苹果",inputKey.apple]
    ,["pingguo",inputKey.apple]
    ,["苹果手机",inputKey.apple]
    ,["pingguoshouji",inputKey.apple]
    ,["apple",inputKey.apple]

    ,["脸书",inputKey.facebook]
    ,["lianshu",inputKey.facebook]
    ,["lianpuwang",inputKey.facebook]
    ,["脸谱网",inputKey.facebook]
    ,["facebook",inputKey.facebook]

    ,["微软",inputKey.microsoft]
    ,["weiruan",inputKey.microsoft]
    ,["微软官网",inputKey.microsoft]
    ,["weiruanguanwang",inputKey.microsoft]
    ,["巨硬",inputKey.microsoft]
    ,["juying",inputKey.microsoft]
    ,["microsoft",inputKey.microsoft]

    ,["东方网",inputKey.dongfangwang]
    ,["dongfangwang",inputKey.dongfangwang]

    ,["天猫超市",inputKey.chaoshitmall]
    ,["tianmaochaoshi",inputKey.chaoshitmall]

    ,["有道云笔记",inputKey.youdaonote]
    ,["youdaoyunbiji",inputKey.youdaonote]
    ,["网易云笔记",inputKey.youdaonote]
    ,["wangyiyunbiji",inputKey.youdaonote]

    ,["红网",inputKey.hongwang]
    ,["hongwang",inputKey.hongwang]

    ,["instagram",inputKey.instagram]

    ,["阿里云",inputKey.aliyun]
    ,["aliyun",inputKey.aliyun]

    ,["站长之家",inputKey.chinaz]
    ,["zhanzhangzhijia",inputKey.chinaz]
    ,["chinaz",inputKey.chinaz]

    ,["花瓣网",inputKey.huaban]
    ,["huabanwang",inputKey.huaban]
    ,["花瓣",inputKey.huaban]
    ,["huaban",inputKey.huaban]

    ,["凤凰网",inputKey.ifeng]
    ,["fenghuangwang",inputKey.ifeng]
    ,["ifeng",inputKey.ifeng]

    ,["领英",inputKey.linkedin]
    ,["lingying",inputKey.linkedin]
    ,["linkedin",inputKey.linkedin]

    ,["苏宁",inputKey.suning]
    ,["苏宁易购",inputKey.suning]
    ,["suning",inputKey.suning]
    ,["suningyigou",inputKey.suning]

    ,["手机中国",inputKey.cnmo]
    ,["shoujizhongguo",inputKey.cnmo]
    ,["cnmo",inputKey.cnmo]

    ,["战旗",inputKey.zhanqi]
    ,["zhanqi",inputKey.zhanqi]
    ,["战旗tv",inputKey.zhanqi]
    ,["zhanqitv",inputKey.zhanqi]
    ,["战旗直播",inputKey.zhanqi]
    ,["zhanqizhibo",inputKey.zhanqi]

    ,["未来网",inputKey.k618]
    ,["weilaiwang",inputKey.k618]

    ,["58",inputKey.wuba]
    ,["58同城",inputKey.wuba]
    ,["58tongcheng",inputKey.wuba]

    ,["证券之星",inputKey.stockstar]
    ,["zhengquanzhixing",inputKey.stockstar]
    ,["stockstar",inputKey.stockstar]

    ,["脚本之家",inputKey.jb51]
    ,["jiaobenzhijia",inputKey.jb51]
    ,["jb51",inputKey.jb51]

    ,["52pk",inputKey.pk52]
    ,["52pk游戏网",inputKey.pk52]
    ,["52pkyouxiwang",inputKey.pk52]

    ,["今日头条",inputKey.toutiao]
    ,["jinritoutiao",inputKey.toutiao]

    ,["迅雷",inputKey.xunlei]
    ,["xunlei",inputKey.xunlei]

    ,["英国广播公司",inputKey.bbc]
    ,["bbc",inputKey.bbc]
    ,["yingguoguangbogongsi",inputKey.bbc]

    ,["推特",inputKey.twitter]
    ,["twitter",inputKey.twitter]
    ,["tuite",inputKey.twitter]

    ,["ebay",inputKey.ebay]
    ,["易趣",inputKey.ebay]
    ,["yiqu",inputKey.ebay]

    ,["tumblr",inputKey.tumblr]

    ,["小米",inputKey.mi]
    ,["小米官网",inputKey.mi]
    ,["小米手机",inputKey.mi]
    ,["xiaomi",inputKey.mi]
    ,["xiaomiguanwang",inputKey.mi]
    ,["xiaomishouji",inputKey.mi]

    ,["智联招聘",inputKey.zhaopin]
    ,["zhilianzhaopin",inputKey.zhaopin]

    ,["同程旅游",inputKey.ly]
    ,["tongchenglvyou",inputKey.ly]

    ,["齐家",inputKey.jia]
    ,["qijia",inputKey.jia]
    ,["齐家网",inputKey.jia]
    ,["qijiawang",inputKey.jia]

    ,["adobe",inputKey.adobe]

    ,["虎扑",inputKey.hupu]
    ,["hupu",inputKey.hupu]

    ,["简书",inputKey.jianshu]
    ,["jianshu",inputKey.jianshu]

    ,["126",inputKey.mail126]
    ,["126邮箱",inputKey.mail126]
    ,["126youxiang",inputKey.mail126]

    ,["163邮箱",inputKey.mail163]
    ,["163youxiang",inputKey.mail163]

    ,["4399",inputKey.sisanjiujiu]

    ,["大众点评",inputKey.dianping]
    ,["dazhongdianping",inputKey.dianping]

    ,["3dm",inputKey.sandm]
    ,["3大妈",inputKey.sandm]
    ,["三大妈",inputKey.sandm]

    ,["游民星空",inputKey.gamersky]
    ,["youminxingkong",inputKey.gamersky]
    ,["gamersky",inputKey.gamersky]

    ,["金山毒霸",inputKey.duba]
    ,["jinshanduba",inputKey.duba]
    ,["duba",inputKey.duba]
    ,["毒霸",inputKey.duba]

    ,["熊猫",inputKey.panda]
    ,["xiongmao",inputKey.panda]
    ,["熊猫tv",inputKey.panda]
    ,["xiongmaotv",inputKey.panda]
    ,["熊猫直播",inputKey.panda]
    ,["xiongmaozhibo",inputKey.panda]

    ,["steam",inputKey.steampowered]
    ,["steampowered",inputKey.steampowered]

    ,["土巴兔",inputKey.to8to]
    ,["tubatu",inputKey.to8to]

    ,["威锋网",inputKey.feng]
    ,["weifengwang",inputKey.feng]
    ,["weifeng",inputKey.feng]
    ,["威锋",inputKey.feng]

    ,["nga",inputKey.ngacn]
    ,["nga玩家社区",inputKey.ngacn]
    ,["ngawanjiashequ",inputKey.ngacn]

    ,["17173",inputKey.yaoqiyaoqisan]

    ,["wordpress",inputKey.wordpress]

    ,["51cto",inputKey.cto51]

    ,["什么值得买",inputKey.smzdm]
    ,["shenmezhidemai",inputKey.smzdm]
    ,["smzdm",inputKey.smzdm]

    ,["w3school",inputKey.w3school]

    ,["w3schools",inputKey.w3schools]

    ,["人人网",inputKey.renren]
    ,["renrenwang",inputKey.renren]
    ,["renren",inputKey.renren]

    ,["v2ex",inputKey.v2ex]

    ,["菜鸟教程",inputKey.runoob]
    ,["cainiaojiaocheng",inputKey.runoob]
    ,["runoob",inputKey.runoob]

    ,["贝宝",inputKey.paypal]
    ,["paypal",inputKey.paypal]
    ,["beibao",inputKey.paypal]

    ,["tieba",inputKey.tieba]
    ,["百度贴吧",inputKey.tieba]
    ,["baidutieba",inputKey.tieba]
    ,["贴吧",inputKey.tieba]

    ,["国美",inputKey.gome]
    ,["guomei",inputKey.gome]
    ,["gome",inputKey.gome]

    ,["汽车之家",inputKey.autohome]
    ,["qichezhijia",inputKey.autohome]
    ,["autohome",inputKey.autohome]

    ,["fangtianxia",inputKey.fang]
    ,["房天下",inputKey.fang]

    ,["携程",inputKey.ctrip]
    ,["xiecheng",inputKey.ctrip]
    ,["携程旅行网",inputKey.ctrip]
    ,["xiechenglvxingwang",inputKey.ctrip]
    ,["ctrip",inputKey.ctrip]

    ,["12306",inputKey.yaoersanlingliu]

    ,["瓜子",inputKey.guazi]
    ,["瓜子二手车",inputKey.guazi]
    ,["guazi",inputKey.guazi]
    ,["guaziershouche",inputKey.guazi]

    ,["去哪网",inputKey.qunar]
    ,["qunawang",inputKey.qunar]

    ,["booking",inputKey.booking]

    ,["途牛",inputKey.tuniu]
    ,["途牛旅游网",inputKey.tuniu]
    ,["tuniu",inputKey.tuniu]
    ,["tuniulvyouwang",inputKey.tuniu]

    ,["mafengwo",inputKey.mafengwo]
    ,["马蜂窝",inputKey.mafengwo]

    ,["飞猪",inputKey.feizhu]
    ,["feizhu",inputKey.feizhu]
    ,["alitrip",inputKey.feizhu]

    ,["起点",inputKey.qidian]
    ,["qidian",inputKey.qidian]
    ,["起点中文网",inputKey.qidian]
    ,["qidianzhongwenwang",inputKey.qidian]

    ,["晋江",inputKey.jinjiang]
    ,["jinjiang",inputKey.jinjiang]
    ,["晋江文学城",inputKey.jinjiang]
    ,["jinjiangwenxuecheng",inputKey.jinjiang]

    ,["太平洋电脑网",inputKey.pconline]
    ,["taipingyangdiannaowang",inputKey.pconline]
    ,["pconline",inputKey.pconline]

    ,["ithome",inputKey.ithome]
    ,["it之家",inputKey.ithome]
    ,["itzhijia",inputKey.ithome]

    ,["zealer",inputKey.zealer]

    ,["虎牙",inputKey.huya]
    ,["huya",inputKey.huya]
    ,["huyatv",inputKey.huya]
    ,["虎牙tv",inputKey.huya]
    ,["虎牙直播",inputKey.huya]
    ,["huyazhibo",inputKey.huya]

    ,["longzhu",inputKey.longzhu]
    ,["龙珠",inputKey.longzhu]
    ,["龙珠tv",inputKey.longzhu]
    ,["longzhutv",inputKey.longzhu]
    ,["龙珠直播",inputKey.longzhu]
    ,["longzhuzhibo",inputKey.longzhu]

    ,["赶集",inputKey.ganji]
    ,["ganji",inputKey.ganji]
    ,["赶集网",inputKey.ganji]
    ,["ganjiwang",inputKey.ganji]

    ,["百姓网",inputKey.baixing]
    ,["baixingwang",inputKey.baixing]

    ,["贝壳找房",inputKey.beike]
    ,["beikezhaofang",inputKey.beike]

    ,["链家",inputKey.lianjia]
    ,["lianjia",inputKey.lianjia]

    ,["我爱我家",inputKey.woaiwojia]
    ,["woaiwojia",inputKey.woaiwojia]

    ,["美团",inputKey.meituan]
    ,["meituan",inputKey.meituan]

    ,["华军",inputKey.huajun]
    ,["huajun",inputKey.huajun]
    ,["华军软件园",inputKey.huajun]
    ,["huajunruanjianyuan",inputKey.huajun]

    ,["前程无忧",inputKey.qianchengwuyou]
    ,["qianchengwuyou",inputKey.qianchengwuyou]
    ,["51job",inputKey.qianchengwuyou]

    ,["拉勾",inputKey.lagou]
    ,["lagou",inputKey.lagou]
    ,["拉勾网",inputKey.lagou]
    ,["lagouwang",inputKey.lagou]

    ,["qq邮箱",inputKey.mailqq]
    ,["qqyouxiang",inputKey.mailqq]

    ,["新浪邮箱",inputKey.mailsina]
    ,["xinlangyouxiang",inputKey.mailsina]

    ,["下厨房",inputKey.xiachufang]
    ,["xiachufang",inputKey.xiachufang]

    ,["糗事百科",inputKey.qiushibaike]
    ,["qiushibaike",inputKey.qiushibaike]

    ,["天眼查",inputKey.tianyancha]
    ,["tianyancha",inputKey.tianyancha]

    ,["网易云课堂",inputKey.netstudy]
    ,["wangyiyunketang",inputKey.netstudy]

    ,["慕课网",inputKey.imooc]
    ,["mukewang",inputKey.imooc]
    ,["imooc",inputKey.imooc]

    ,["qq网页版",inputKey.qqweb]
    ,["网页版qq",inputKey.qqweb]
    ,["qqwangyeban",inputKey.qqweb]
    ,["wangyebanqq",inputKey.qqweb]
    ,["qqweb",inputKey.qqweb]
    ,["webqq",inputKey.qqweb]

    ,["微信网页版",inputKey.weixinweb]
    ,["网页版微信",inputKey.weixinweb]
    ,["weixinwangyeban",inputKey.weixinweb]
    ,["wangyebanweixin",inputKey.weixinweb]
    ,["微信web",inputKey.weixinweb]
    ,["web微信",inputKey.weixinweb]
    ,["weixinweb",inputKey.weixinweb]
    ,["webweixin",inputKey.weixinweb]

    ,["腾讯云",inputKey.tencentcloud]
    ,["tengxunyun",inputKey.tencentcloud]
    ,["tencentcloud",inputKey.tencentcloud]

    ,["aws",inputKey.aws]
    ,["亚马逊云",inputKey.aws]
    ,["yamaxunyun",inputKey.aws]

    ,["azure",inputKey.azure]
    ,["微软云",inputKey.azure]
    ,["weiruanyun",inputKey.azure]

    ,["googlecloud",inputKey.googlecloud]
    ,["谷歌云",inputKey.googlecloud]
    ,["gugeyun",inputKey.googlecloud]

    ,["安居客",inputKey.anjuke]
    ,["anjuke",inputKey.anjuke]

    ,["半次元",inputKey.bcy]
    ,["banciyuan",inputKey.bcy]
    ,["bcy",inputKey.bcy]

    ,["菜鸟裹裹",inputKey.guoguo]
    ,["cainiaoguoguo",inputKey.guoguo]

    ,["电信",inputKey.dianxin]
    ,["中国电信",inputKey.dianxin]
    ,["dianxin",inputKey.dianxin]
    ,["zhongguodianxin",inputKey.dianxin]

    ,["移动",inputKey.yidong]
    ,["中国移动",inputKey.yidong]
    ,["yidong",inputKey.yidong]
    ,["zhongguoyidong",inputKey.yidong]

    ,["联通",inputKey.liantong]
    ,["中国联通",inputKey.liantong]
    ,["liantong",inputKey.liantong]
    ,["zhongguoliantong",inputKey.liantong]

    ,["高德",inputKey.gaode]
    ,["高德地图",inputKey.gaode]
    ,["gaode",inputKey.gaode]
    ,["gaodeditu",inputKey.gaode]
    ,["gaodemap",inputKey.gaode]
    ,["amap",inputKey.gaode]

    ,["百度地图",inputKey.baidumap]
    ,["baiduditu",inputKey.baidumap]
    ,["baidumap",inputKey.baidumap]

    ,["腾讯地图",inputKey.tencentmap]
    ,["tengxunditu",inputKey.tencentmap]
    ,["tencentmap",inputKey.tencentmap]

    ,["googlemap",inputKey.googlemap]
    ,["谷歌地图",inputKey.googlemap]
    ,["gugeditu",inputKey.googlemap]

    ,["滴滴",inputKey.didi]
    ,["滴滴打车",inputKey.didi]
    ,["didi",inputKey.didi]
    ,["dididache",inputKey.didi]

    ,["饿了么",inputKey.eleme]
    ,["eleme",inputKey.eleme]

    ,["美团外卖",inputKey.meituanwaimai]
    ,["meituanwaimai",inputKey.meituanwaimai]

    ,["koubei",inputKey.koubei]
    ,["口碑",inputKey.koubei]

    ,["gmail",inputKey.gmail]
    ,["谷歌邮箱",inputKey.gmail]
    ,["gugeyouxiang",inputKey.gmail]

    ,["百度翻译",inputKey.baidutranslate]
    ,["baidufanyi",inputKey.baidutranslate]
    ,["baidutranslate",inputKey.baidutranslate]

    ,["有道翻译",inputKey.youdaotranslate]
    ,["youdaotranslate",inputKey.youdaotranslate]
    ,["youdaofanyi",inputKey.youdaotranslate]

    ,["喜马拉雅",inputKey.ximalaya]
    ,["ximalaya",inputKey.ximalaya]

    ,["微博",inputKey.weibo]
    ,["weibo",inputKey.weibo]

    ,["果壳网",inputKey.guoke]
    ,["guokewang",inputKey.guoke]
    ,["果壳",inputKey.guoke]
    ,["guoke",inputKey.guoke]

    ,["腾讯课堂", inputKey.tencentstudy]
    ,["tengxunketang", inputKey.tencentstudy]

  ]
)
export default openArgument



// WEBPACK FOOTER //
// ./src/cnConst/openArgument.js